const INFO = {
	main: {
		title: "My Portfolio",
		name: "Than Kywe",
		email: "thankywe1997@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/Than890",
		linkedin: "https://www.linkedin.com/in/than-kywe",
	},

	homepage: {
		title: "Tech Enthusiast",
		description:
		"I am a backend developer skilled in building scalable, secure web applications using Node.js, NestJS, Laravel and modern backend technologies. Passionate about writing clean, high-quality code, optimizing performance, and architecting efficient APIs, I tackle complex challenges and continuously explore innovations in backend development."
	},

	about: {
		title: "I'm Than Kywe (Ah Kywe) - Innovating from Myanmar",
		description:
			"I've worked on diverse projects over the years, focusing on creating impactful, innovative solutions. Many of these are not open-source, but I still welcome collaboration and feedback. If you're interested in exploring my work or have ideas for improvements, feel free to reach out. Collaborating with others helps me grow and stay inspired.",
	},

	contact: {
		title: "Let's Get in Touch: Ways to Connect with Me",
		description: "Thank you for reaching out! I welcome your feedback and questions. You can email me directly, and I aim to respond within 24 hours. Looking forward to hearing from you!",
		phone: {
			title: "Phone",
			value: "+95 9 969 889 147"
		},
		email: {
			title: "Email",
			value: "thankywe1997@gmail.com"
		},
		// location: {
		// 	title: "Location",
		// 	value: "Yangon, Myanmar"
		// }
	},

	articles: {
		title: "Articles & Insights",
		description: "Thoughts, tutorials, and insights from my journey in backend development and software architecture.",
		list: [
			{
				title: "Building Scalable APIs with Node.js",
				description: "Best practices for creating robust and scalable REST APIs using Node.js and Express.js.",
				link: "/article/1"
			},
			{
				title: "Database Design Patterns for Backend Developers",
				description: "Essential database design patterns and optimization strategies for backend applications.",
				link: "/article/2"
			},
			{
				title: "Microservices Architecture: Lessons Learned",
				description: "Real-world insights and challenges when implementing microservices in production environments.",
				link: "/article/3"
			}
		]
	},

	works: [
		{
			company: "CloudE8 Pte Ltd",
			position: "Software Developer",
			duration: "May 2024 - Present",
		},
		{
			company: "Solinx Technology",
			position: "Senior Backend Developer",
			duration: "Nov 2023 - Apr 2024",
		},
		{
			company: "EDKA Digital",
			position: "Senior Backend Developer",
			duration: "Jul 2022 - Aug 2023",
		},
		{
			company: "Global New Wave Technology",
			position: "Backend Developer",
			duration: "Mar 2020 - Jun 2022",
		},
		{
			company: "Studio AMK Pte. Ltd",
			position: "Internship Program",
			duration: "Sep 2019 - Dec 2019",
		},
	],

	projects: [
		{
			title: "PTB GO – Ecommerce",
			description:"Built an e-commerce platform with order, delivery, and reporting modules, integrated Sai Sai Pay for payments, used GraphQL for real-time tracking, and developed APIs for mobile apps and website.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},

		{
			title: "MyHealthCare Pharmacy MarketPlace",
			description:
				"Created an online pharmacy marketplace with order, supplier, and delivery modules, implemented GraphQL for real-time tracking, and developed APIs for mobile apps and website.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},

		{
			title: "POSEM Multi POS System",
			description:
				"Created APIs for mobile POS systems, developed a web portal, and integrated payments using Dinger with Node.js, Express.js, and MongoDB.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},

		{
			title: "XH EXPRESS",
			description:
				"China to Myanmar Delivery System: Built a delivery system with a structured backend using Nest.js and MySQL, providing APIs for counter apps, user app, and admin dashboard.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},
		{
			title: "Token Doctor Queue Management System",
			description:
				"Developed a queue management system for doctors with Nest.js, implemented mobile and web APIs, and integrated Dinger for payments.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},

		{
			title: "Aung Thamar Di - ERP",
			description:
				"Built an ERP system with HR, IT, and gold sales management modules, developed APIs for web and mobile applications, and implemented a new backend architecture using Node.js, Express.js, and TypeScript.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},
		{
			title: "Cutting Men - Goldsmith Management System",
			description:
				"Designed a system for tracking gold product assignments, payroll, and production management for goldsmiths with reporting features using Node.js, Express.js, and TypeScript.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},
		{
			title: "LanYin-Gold and Jewellery POS",
			description:
				"Developed a POS system for jewelry sales with a new backend architecture and provided APIs for order, supplier, and sales management using Node.js, Express.js, and TypeScript.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},
		{
			title: "NewTaiSin-Gold and Jewellery POS",
			description:
				"Developed a custom POS system for gold and jewelry sales with role management, order, stock, and sales modules using Node.js, Express.js, TypeScript, and MySQL",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		},
	],
};

export default INFO;
